import { RouteType } from "types/RouteType";
import ClientRiskStore from "./ClientRiskStore";

const clientRiskRoute: RouteType[] = [
  {
    name: "ClientRisk",
    path: "/clients/risk",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Client Risk",
        enableRefreshButton: true,
        component: () => import("./ClientRisk.Header"),
      },
      body: {
        component: () => import("./ClientRisk"),
        grayBackground: true,
      },
    },
    group: "Clients",
    searchAliases: ["account health", "at risk", "churn"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.clientRiskStore as ClientRiskStore;
      store?.load();
    },
  },
];

export default clientRiskRoute;
